import axiosClient from "../ApiClient";

export function verifyEmail(token) {
  return axiosClient.get("/web/registrationConfirm", {
    params: {
      token: token,
    },
  });
}
